module.exports = __webpack_public_path__ + "img/woodlands.6e8119e3.png";